module.exports = __webpack_public_path__ + "media/images/icons/backArrow-d00e85b983b82326ffdaaca324ffbd34.svg";